import { render, staticRenderFns } from "./exceptionForm.vue?vue&type=template&id=6ba97cca"
import script from "./exceptionForm.vue?vue&type=script&lang=js"
export * from "./exceptionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports